import axios from 'axios'
import * as MODULES from '../module-codes'

export const state = {
  pcs_roles: [],
}

export const getters = {
  pcs_roles: state => {
    return state.pcs_roles
  },
}

export const actions = {

  populateFromDB: async ({ commit, dispatch, state }, payload) => {
    if (payload) {
      commit('POPULATE_MODULE', payload)
    }
  },

  saveState: async ({ state, rootState }) => {
    await axios.post('/api/saveUserRoles', {
      params: {
        pcs: localStorage.getItem('pcs'),
        content: state.pcs_roles,
        classId: rootState.auth.classId,
      },
    })
  },

  updateState: ({ commit, dispatch }, payload) => {
    commit('UPDATE_ROLES', payload)
    dispatch('saveState')
  },
}

export const mutations = {

  POPULATE_MODULE: (state, newState) => {
    state.pcs_roles = newState
  },

  UPDATE_ROLES: (state, payload) => {
    state.pcs_roles = payload
  },
  CLEAR_STATE: state => {
    state.pcs_roles = []
  },
}
